import { SignIn, SignUp } from "@clerk/react";

const Wrap = ({ children }) => (
  <section className="min-h-[80vh] flex items-center justify-center py-16 px-4">{children}</section>
);

export const SignInPage = () => (
  <Wrap><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></Wrap>
);

export const SignUpPage = () => (
  <Wrap><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></Wrap>
);
